/* This is a global entry point for a main layout */

import 'babel-polyfill';

import '../styles/site.scss';

import * as Core from "./Core";
import * as Directives from "./Core";
import Vue from "vue";
import * as moment from "moment";
import { MomentHelper } from "./Helpers/MomentHelper";
import VueSelect from "./Components/VueSelect/VueSelect.vue";
import Modal from "./Components/Modal/Modal.vue";
import VueCarousel from 'vue-carousel';
import VueSticky from "./Directives/Sticky/StickyDirective";
import '../../node_modules/@brightspark/sparkling-xelect-js/css/sparkling-xelect.css';

import enums from "./enum";

declare global {
    interface Window {
        __REQUEST_VIEW: string;
        __VIEW_DATA: any;
        __URI: any;
        view: Core.IView;
    }
}

MomentHelper.initLocale();

Vue.directive("init", new Directives.InitDirective());
Vue.directive("sticky", VueSticky);

Vue.component(VueCarousel);
Vue.component("v-select", VueSelect);

Vue.component("v-modal", Modal);

//TODO locate to proper place
Vue.filter('toCurrency', value => {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('et-EE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});
Vue.filter('n2', value => {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('et-EE', {
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});


Vue.filter('d', function (value) {
    if (value) {
        return moment(String(value)).format("L");
    }
});

if (window.__REQUEST_VIEW) {
    window.view = Core.ViewFactory.createView(window.__REQUEST_VIEW);
}

// This is a global mixin, it is applied to every vue instance
Vue.mixin({
    data: function () {
        return {
            get global() {
                return {
                    enum: enums
                };
            }
        }
    }
});


// WEBPACK FOOTER //
// ./www/js/App.ts